// extracted by mini-css-extract-plugin
export default {"map":"SingleAssetDetails_map__QKEPC","actions":"SingleAssetDetails_actions__qBBny"};